const impressao_de_analise_de_relatorio_final = [
  {
    path: "/impressao-de-analise-de-relatorio-final",
    name: "impressao_de_analise_de_relatorio_final",
    meta: {
      allowedPermissions: ["relatoriofinal_analise"],
      breadCrumb: "Processo de Resultado Final - Relatório Final da Escola",
    },
    component: () =>
      import(
        "@/views/ImpressaoDeAnaliseDeRelatorioFinal/ImpressaoDeAnaliseDeRelatorioFinal.vue"
      ),
  },
];

export { impressao_de_analise_de_relatorio_final };
